var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.merchantList,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.selectedmerchant
    },
    on: {
      "select": _vm.selectMerchant
    },
    model: {
      value: (_vm.merchantnameFlt),
      callback: function($$v) {
        _vm.merchantnameFlt = $$v
      },
      expression: "merchantnameFlt"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.slaflag) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sla.sla')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSLA),
      expression: "searchSLA"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchSLA"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSLA = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.selectSLA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Within SLA"
    }
  }, [_vm._v("Within SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near SLA"
    }
  }, [_vm._v("Near SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SLA Breached"
    }
  }, [_vm._v("SLA Breached")])])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderNumber')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ponoFlt",
      "placeholder": _vm.$t('orders.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.ponoFlt),
      callback: function($$v) {
        _vm.ponoFlt = $$v
      },
      expression: "ponoFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "shipidflt",
      "placeholder": _vm.$t('orders.shipmentIdPlaceHolder')
    },
    model: {
      value: (_vm.shipidflt),
      callback: function($$v) {
        _vm.shipidflt = $$v
      },
      expression: "shipidflt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.salesChannelPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                          " + _vm._s(channel.saleschannel))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchstatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.hideShowdateFlt]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderStatusPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.orderstatuslist), function(ordstatus) {
    return _c('option', {
      domProps: {
        "value": ordstatus.status
      }
    }, [_vm._v("\n                          " + _vm._s(ordstatus.status))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.fromShipDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFltShip),
      callback: function($$v) {
        _vm.fromDateFltShip = $$v
      },
      expression: "fromDateFltShip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toShipDate')) + "  ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFltShip),
      callback: function($$v) {
        _vm.toDateFltShip = $$v
      },
      expression: "toDateFltShip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.FromDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.PreviousDayFlag) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.warningflag) ? _c('span', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "warning"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('orders.info')) + "!")]), _vm._v(" " + _vm._s(_vm.$t('orders.dateIsOfPrevDay')) + ".")])], 1) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    on: {
      "change": function($event) {
        _vm.Datechange()
      }
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1) : _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    on: {
      "change": function($event) {
        _vm.Datechange()
      }
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.statusFlag == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.labelfromdate) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFltStatus),
      callback: function($$v) {
        _vm.fromDateFltStatus = $$v
      },
      expression: "fromDateFltStatus"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statusFlag == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.labeltodate) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFltStatus),
      callback: function($$v) {
        _vm.toDateFltStatus = $$v
      },
      expression: "toDateFltStatus"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.multiOrder')) + "  :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ponoFlt",
      "placeholder": _vm.$t('orders.orderNumberPlaceHolder')
    },
    on: {
      "change": function($event) {
        _vm.getOrderCount()
      }
    },
    model: {
      value: (_vm.MultiorderIDS),
      callback: function($$v) {
        _vm.MultiorderIDS = $$v
      },
      expression: "MultiorderIDS"
    }
  })], 1)], 1), _vm._v(" "), (_vm.MultiorderArrFlag) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.OverOrdersErr) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.b2BOrder')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchbtoborder),
      expression: "searchbtoborder"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "searchbtoborder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchbtoborder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.selectB2BOrder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('orders.b2BOrder')) + " ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('orders.nonB2BOrder')) + " ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.selectSelfshipStatus')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchselfship),
      expression: "searchselfship"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "searchselfship"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchselfship = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.all')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('boxList.selfShipped')) + " ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('orders.nonSelfShipped')) + " ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rtv')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtvType),
      expression: "rtvType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "rtvType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rtvType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.selectrtvtype')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTV/Accept"
    }
  }, [_vm._v("RTV/Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTV/Reject"
    }
  }, [_vm._v("RTV/Reject")])])])], 1), _vm._v(" "), (_vm.checkCrossDock) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important",
      "margin-top": "30px",
      "width": "16px"
    }
  }, [_c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "iscrossdock",
      "name": "iscrossdock"
    },
    model: {
      value: (_vm.iscrossdock),
      callback: function($$v) {
        _vm.iscrossdock = $$v
      },
      expression: "iscrossdock"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "3px",
      "color": "black !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "iscrossdock"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('config.crossdock')))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading || _vm.MultiorderArrFlag
    },
    on: {
      "click": function($event) {
        _vm.getOrderSerach(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v("\n                       "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 s2 o1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('orders.orderList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 s2 o2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 s1 o3"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.resultCount))])]), _vm._v(" "), _c('div', {
    staticClass: " cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listOrdersData.length > 0 && _vm.downloadButtonFlag == true) ? _c('div', {
    staticClass: "col-md-2 s1 o4"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 csvbtn"
  }, [_c('span', [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getOrderList(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listOrdersData.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 xlsbtn"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardtable cardreporttablerow",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.customerName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalQTY')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('merchant.merchantName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ordercode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipstatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipByDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentHandoverDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.ordercompletionhrs')))])]), _vm._v(" "), (_vm.slaflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('sla.sla')))]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.displayCancel) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.action')))])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.OderqtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderPlaceHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listOrdersData), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [(data.btoborder == 1) ? _c('i', {
      staticClass: "fa fa-briefcase",
      staticStyle: {
        "margin-top": "5px",
        "float": "left"
      },
      attrs: {
        "title": "B2B Order"
      }
    }) : _vm._e(), _vm._v(" "), (data.status != 'Rejected') ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "title": "View Order Details"
      },
      on: {
        "click": function($event) {
          _vm.showAddForm(data)
        }
      }
    }, [_vm._v(_vm._s(data.orderid))]) : _vm._e(), _vm._v(" "), (data.status == 'Rejected') ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "title": "View Rejected Order Details"
      },
      on: {
        "click": function($event) {
          _vm.showRejectInfo(data.orderid)
        }
      }
    }, [_vm._v(_vm._s(data.orderid))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.customerfirstname) + " " + _vm._s(data.customerlastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderdate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sellername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ordercode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.shipmentDetails(data.orderid, data.shipmentcount)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.shipmentcount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), (data.shipmentstatus.indexOf('rto') == -1) ? _c('td', [_vm._v(_vm._s(data.status) + "\n\n                    "), (data.shipmentstatus.indexOf('rto') > -1) ? _c('span', {
      staticClass: "fa fa-cart-plus",
      staticStyle: {
        "font-size": "17px",
        "color": "#ff9900"
      },
      attrs: {
        "title": "Shipment with multiple status"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (data.shipmentstatus.indexOf('rto') > -1) ? _c('td', [_vm._v("rto\n                    "), (data.shipmentstatus.indexOf('dispatched') > -1) ? _c('span', {
      staticClass: "fa fa-cart-plus",
      staticStyle: {
        "font-size": "17px",
        "color": "#ff9900"
      },
      attrs: {
        "title": "Shipment with multiple status"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipbydate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderdispatchdatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ordercompletionhrs))]), _vm._v(" "), (_vm.slaflag) ? _c('td', [_vm._v("\n                    " + _vm._s(data.sladatetime) + " "), _c('br'), _vm._v(" "), (data.slastatus == 'SLA Breached') ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('sla.slabreached')))]) : (data.slastatus == 'Near SLA') ? _c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.sladiff / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.sladiff % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : (data.slastatus == 'Within SLA') ? _c('span', {
      staticClass: "badge badge-info",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.sladiff / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.sladiff % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.source))]), _vm._v(" "), (_vm.displayCancel) ? _c('td', [(_vm.cancelOrderFlag == true) ? _c('span', [(data.status != 'Rejected' && data.status != 'dispatched' && data.status != 'cancelled' && data.status != 'sr' && data.status != 'rto' && data.shipmentcount) ? _c('i', {
      staticClass: "fa fa-times fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "Cancel Order"
      },
      on: {
        "click": function($event) {
          _vm.orderCancelShow = true;
          _vm.cancelOrderId = data.orderid;
          _vm.cancelshipmentid = data.shipmentcount;
          _vm.OthersReason = ''
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.status == 'Rejected' && data.source == 'Unicommerce') ? _c('i', {
      staticClass: "fa fa-refresh fa-lg",
      staticStyle: {
        "color": "lightseagreen",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Pull Order"
      },
      on: {
        "click": function($event) {
          _vm.PullRejectOrders(data)
        }
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.multiselectflag == false) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.values) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto",
      "height": "147px"
    }
  }, [(_vm.values) ? _c('label', {
    staticStyle: {
      "width": "900px",
      "overflow-wrap": "break-word"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('orders.orderIDNotFound')) + " ")]), _vm._v(":\n              " + _vm._s(this.values))]) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "PO details"
    },
    model: {
      value: (_vm.showinvoicemodal),
      callback: function($$v) {
        _vm.showinvoicemodal = $$v
      },
      expression: "showinvoicemodal"
    }
  }, [_c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "orderinvoiceContent"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('i', {
    on: {
      "ok": function($event) {}
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important",
      "font-size": "12px"
    },
    attrs: {
      "width": "100%",
      "border": "1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%",
      "colspan": "2"
    }
  }, [_c('span', [_c('strong', [_vm._v("Name:")]), _vm._v("\n                         " + _vm._s(_vm.clientdata.clientname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Address:")]), _vm._v("  " + _vm._s(_vm.clientdata.clientaddress) + "," + _vm._s(_vm.clientdata.clientaddress2) + "," + _vm._s(_vm.clientdata.city) + " –\n                        " + _vm._s(_vm.clientdata.pincode))]), _vm._v("\n                      Ph :- 18002082222\n                    ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Details Of Recevier\n                          (Patient):")])]), _c('br'), _c('span', [_c('strong', [_vm._v("Name:")]), _vm._v(_vm._s(_vm.shippingdata.customerfirstname) + " " + _vm._s(_vm.shippingdata.customerlastname) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("GST In: ")]), _vm._v("36AALCM3440J1ZB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.shippingdata.custaddress1) + "," + _vm._s(_vm.shippingdata.custstate) + "," + _vm._s(_vm.shippingdata.custcity)), _c('br'), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("CIN:")]), _vm._v(" U72900TG2017PTC119669")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("State: ")]), _vm._v(_vm._s(_vm.shippingdata.custstate))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("\n                          DL NO:")]), _vm._v(" TS-RR-20-2018-38388 , TS-RR-21-2018-38388")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("State /UI Code: ")]), _vm._v(" " + _vm._s(_vm.shippingdata.custpincode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Order Id:")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingdata.orderid))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("GST Unique Id:")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Serial No Of Invoice: ")]), _vm._v(_vm._s(_vm.shippingdata.invoicenumber))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("DOC Name:")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingdata.doctorname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none !important"
    },
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Date Of Invoice:\n                        ")]), _c('span', [_vm._v(_vm._s(_vm.shippingdata.shippingoutdate))])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Address:")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingdata.doctoraddress))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "font-size": "10px",
      "border-spacing": "0px !important",
      "margin-top": "5px"
    },
    attrs: {
      "border": "1",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Item Description")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "max-width": "8%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Manufacturer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Strength")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Batch Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Expiry date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      HSN/SAC")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("QTY\n                    ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("UOM\n                    ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      MRP(per item)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Total MRP(A)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Discount Amount(B)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "9px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Amount Payable(A-B)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                      Taxable Value")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                      CGST ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                      SGST ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-bottom": "none !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("IGST ")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v("\n                      Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v("\n                      Amt.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v("\n                      Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v("\n                      Amt.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important",
      "border-right": "none !important"
    }
  }, [_vm._v("\n                      Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%",
      "font-size": "10px",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Amt.")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shippinginvoicedatacal), function(invoicedata) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "8%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.productname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.strength))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.lotcontrol))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [(invoicedata.expirydate != null) ? _c('span', [_vm._v(_vm._s(invoicedata.expirydate))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.hsncode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.pickqty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.primaryuom))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.mrp)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.totalmrp)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.discount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.amountpayable)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "9px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.taxablevalue)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.cgstper))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.cgstamount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.sgstper))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.sgstamount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "border-right": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(invoicedata.igstper))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "font-size": "10px",
        "border-bottom": "none !important",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(invoicedata.igstamount)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "8%",
      "font-size": "11px",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.totalqty) + "\n                    ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(_vm.grdtotalmrp)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(_vm.totalamountpayable)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(_vm.totaltaxablevalue)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(_vm.totalcgstamt)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important",
      "text-align": "right"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.formatPrice(_vm.totalsgstamt)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "border-right": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "6%",
      "font-size": "10px",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totaligstamt)))])])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important",
      "font-size": "10px"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr'), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Total\n                          Amount Payable: ₹ " + _vm._s(_vm.formatPrice(_vm.totalamountpayable)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Delivery\n                          Charges(inclusive of taxes): ₹ " + _vm._s(_vm.shippingcharges))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Total\n                          Invoice Value (In Figure): ₹ " + _vm._s(_vm.formatPrice(_vm.totalamountpayable + _vm.shippingcharges)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Total\n                          Invoice Value (In Words): " + _vm._s(_vm.number2text(_vm.totalamountpayable + _vm.shippingcharges)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Amount of\n                          Tax subject to Reverse Charges: NIL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "980px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    }
  }, [_vm._v("Remarks:\n                        ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px",
      "padding-left": "4px",
      "border-left": "none !important",
      "border-bottom": "none !important"
    },
    attrs: {
      "width": "70%",
      "rowspan": "4"
    }
  }, [_c('span', [_c('p', [_c('br'), _vm._v(" Customer Acknowledgement"), _c('br'), _vm._v(" I, the undersigned hereby acknowledge the delivery of\n                            my order in full as prescribed by my Doctor and sent to Health Folks for fulfilment upon my\n                            request. I hereby confirm that I have\n                            checked the contents of the delivery and matched the same with the prescription and have\n                            found everything in order. I also understand that Healthfolks is a retail pharmacy\n                            dispensing the order, and is not responsible for\n                            the prescription or consumption of products in the prescription and any untoward incident\n                            arising out of the same. I understand that Healthfolks will store all my personal\n                            information securely in an encrypted format and\n                            that Healthfolks, its directors, employees, partners or affiliates will have no access to my\n                            personal health information unless when necessary for order fulfilment or when specifically\n                            authorized by me. I signed up for\n                            Healthfolks service after having read and accepted all terms and conditions and privacy\n                            policy as laid out on www.Healthfolks.com. All medicines are prescribed after my\n                            consultation with Doctor and delivered by\n                            Healthfolks as directed by me. I have been duly informed to urgently contact my Doctor if I\n                            notice any side-effects upon consumption of any of the products in the order. Goods sold at\n                            MRP. Goods once sold will not be\n                            taken back."), _c('br'), _vm._v(" Please refer to our goods return policy at www.Healthfolks.com. We value\n                            your feedback customercare@Healthfolks.com 18002082222"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Registered\n                              Office:-")]), _vm._v(" "), _c('span', [_vm._v("MNR DATAMIGHT PVT\n                              LTD,2-23B/350, Bhagyanagar Phase-III,Near HMT Hills Colony,Opp: JNTU,KukatpallyHyderabad –\n                              500 085.")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Pharmacist\n                        Signature:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "15%",
      "colspan": "3"
    }
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.invoicephname) + "  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "width": "15%",
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                          RP Number  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none !important",
      "border-bottom": "none !important",
      "border-right": "none !important"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                          Date  ")])])])])])])])])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary  glass",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-left": "19px"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s('Print')
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.print')) + " ")])]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.orderCancelShow),
      callback: function($$v) {
        _vm.orderCancelShow = $$v
      },
      expression: "orderCancelShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('orders.cancelOrder')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.orderCancelShow = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('orders.cancelOrderPopup')) + "?\n\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.cancelReason')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelreasonid),
      expression: "cancelreasonid"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "reason",
      "id": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cancelreasonid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.selectCancelReason')))]), _vm._v(" "), _vm._l((_vm.listCancelReasonData), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.reasonname
      }
    }, [_vm._v("\n                    " + _vm._s(Reason_obj.reasonname))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.others')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OthersReason),
      expression: "OthersReason"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "name": "Others",
      "id": "Others",
      "placeholder": _vm.$t('orders.othersPlaceHolder')
    },
    domProps: {
      "value": (_vm.OthersReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.OthersReason = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [(_vm.cancelshipmentid == '') ? _c('button', {
    staticClass: "btn btn-primary glass float-right",
    staticStyle: {
      "width": "130px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelOrder()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n              " + _vm._s(_vm.$t('orders.cancelOrder')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.cancelshipmentid != '') ? _c('button', {
    staticClass: "btn btn-primary glass float-right",
    staticStyle: {
      "width": "180px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelOrderShipment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n              Cancel Order Shipment\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger glasssec  float-right",
    staticStyle: {
      "width": "130px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.orderCancelShow = false;
        _vm.cancelOrderId = '';
        _vm.cancelreasonid = '';
        _vm.cancelshipmentid = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.back')) + "\n            ")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "shipmentdetails"
    },
    model: {
      value: (_vm.shipmentdetails),
      callback: function($$v) {
        _vm.shipmentdetails = $$v
      },
      expression: "shipmentdetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.shipmentDetailsForOrder')) + " : " + _vm._s(_vm.orderidshipment) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.shipmentDetailsClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.mrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemStatus')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentdetailslist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data.itemid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sku))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.itemstatus))])])
  }), _vm._v(" "), (_vm.shipmentdetailslist.length < 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.table.noRecordFoundMsg')) + " ")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "rejectdetails"
    },
    model: {
      value: (_vm.rejectdetails),
      callback: function($$v) {
        _vm.rejectdetails = $$v
      },
      expression: "rejectdetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('shipment.rejectedOrders')) + " : " + _vm._s(_vm.orderid) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.rejectdetailsClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.itemId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.sku')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('shipment.rejectedReasons')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rejectdetailslist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data.orderitemid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sku))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.linestatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rejectedreasons))])])
  }), _vm._v(" "), (_vm.shipmentdetailslist.length < 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.table.noRecordFoundMsg')) + " ")])]) : _vm._e()], 2)])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showlist == false) ? _c('div', [_c('div', [_c('orderdetailsaccordian', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow,
      "shipwmntwise": 1
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Source")])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-530f58d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530f58d5","hasScoped":true}!./src/views/components/reports/order/order.component.html
// module id = 1487
// module chunks = 0